<template>
    <IEcharts v-if="show"
        :option="bar"
        :resizable="true"
    />
</template>
<script>
import IEcharts from "vue-echarts-v3/src/full.js";
export default {
    components: {
        IEcharts,
    },
    props:{
        dataX:{default:() => {
            return [1,2,3,4,5,6,7,9,10,11,12,13,14,15,16,17,18]
        }},
        dataY:{default:() => {
            return [1,2,3,4,5,6,7,9,10,11,12,13,14,15,16,17,18]
        }},
        update: {default:true},
        updateHight: {default:true},
        updateRight: {default:true},
        gridMode:{default:true}
    },
    data() {
        return {
            bar: {
                grid:{
                    height:'90%',
                    width: "calc(100%-70px)",
                    right:'70px',
                    top:'0'
                },
                tooltip: {
                    show: true,
                    trigger: "axis",
                    axisPointer: {
                    type: "cross",
                    axis: "auto"
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap:false,
                    axisLine:{
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    axisTick: {
                        show: false,
                        alignWithLabel: true,
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    axisLabel: {
                        show: false,
                        align: 'center',
                        color: '#718da8'
                    },
                    splitLine: {
                        show:true,
                        interval:0,
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    data: []
                },
                yAxis: {
                    type: 'value',
                    scale:true,
                    max:8000000,
                    position:'right',
                    splitLine: {
                        show:false
                    },
                    axisPointer: {
                        show:true,
                        type: 'shadow',
                    },
                    axisLine: {
                        show:true,
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    axisTick: {
                        inside: false,
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    axisLabel: {
                        inside: false,
                        align: 'left',
                        verticalAlign:'middle',
                        margin:'8',
                        color:'#718da8'
                    }
                },
                series: [{
                    name:'Доход',
                    data: [],
                    type: 'bar',
                    boundaryGap:true,
                }
                    ]
            },
            show:true
        }
    },
    computed: {
        
    },
    methods: {
       maxY() {
            this.bar.yAxis.max = Math.max(...this.dataY) + 0.4*Math.max(...this.dataY);
            this.bar.xAxis.data = this.dataX;
            this.bar.series[0].data = [];
            let itemStyle = {
                normal: {
                    borderWidth: 3,
                    borderColor: '#ff9292',
                    color: '#ff9292'
                }
            }
            let itemStyleProfit = {
                normal: {
                    borderWidth: 3,
                    borderColor: '#00ffd0',
                    color: '#00ffd0'
                }
            }
            let itemStyleFirst = {
                normal: {
                    //borderWidth: 3,
                    borderColor: '#36e2ff',
                    color: '#36e2ff'
                }
            }
            for(let i = 0; i < this.dataY.length; i++) {
                if (this.dataY[i] < 0) {
                    this.bar.series[0].data.push({value:this.dataY[i].toFixed(2),label:getLabelForBar(this.dataY[i],0,this.gridMode), itemStyle:itemStyle})
                } else {
                    this.bar.series[0].data.push({value:this.dataY[i].toFixed(2),label:getLabelForBar(this.dataY[i],1,this.gridMode), itemStyle:itemStyleProfit})
                }
            }
        }
    },
    watch: {
        dataY: function() {
            this.maxY()
        },
        update: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        updateHight: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        updateRight: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        }
    },
    mounted() {
        this.maxY()
    }
}
function getLabelForBar(stat, indicator, gridMode) {
    let normal =  {
                    show:true,
                    position: indicator > 0 ? 'top' : 'bottom',
                    color:indicator > 0 ? '#00ffd0' : '#ff9292',
                    formatter:'vdvd : dbdbb',
                    fontSize:gridMode ? 6 : '',
                }
    normal.formatter = stat.toFixed(2);
        return normal 
    }
</script>